import { ProfileImportNetworkListTab } from '$provider/constants/ProfileImportNetworkListTab';

/** @type {import('./$types').ParamMatcher} */
export function match(param: string): boolean {
  const tabs = Object.values(ProfileImportNetworkListTab);
  // check the param if the value holds import of merge  it return true
  // If false, Automatically redirect to 403 error
  return !!param && tabs.includes(param);
}
